import { Sparkles } from 'lucide-react';

type AdjustmentPanelProps = {
  correction: string;
  busy: boolean;
  onCorrectionChange: (value: string) => void;
  onApply: () => void;
};

const quickCorrections = [
  'Move it up slightly',
  'Move it down slightly',
  'Make it smaller',
  'Center it',
];

export function AdjustmentPanel({
  correction,
  busy,
  onCorrectionChange,
  onApply,
}: AdjustmentPanelProps) {
  const canApply = !busy && correction.trim().length > 0;

  return (
    <section className="mt-6 rounded-2xl border border-border bg-card p-5 sm:p-6" aria-labelledby="talk-to-ai-title" data-testid="panel-talk-to-ai">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="mono-font text-[10px] uppercase tracking-[.16em] text-primary">Talk to AI</p>
          <h3 id="talk-to-ai-title" className="display-font mt-2 text-2xl">Tell AI what to fix.</h3>
          <p className="mt-2 max-w-md text-sm leading-6 text-muted-foreground">Describe how you want the turban changed and AI will blend it back into your selfie.</p>
        </div>
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary/20 text-primary"><Sparkles size={17} /></span>
      </div>

      <div className="mt-6">
        <label htmlFor="turban-correction" className="text-xs font-bold text-foreground">Or tell AI what to fix about the turban</label>
        <textarea id="turban-correction" value={correction} onChange={(event) => onCorrectionChange(event.target.value)} disabled={busy} rows={3} maxLength={500} placeholder="Try: move it up a little and make it smaller…" className="mt-2 w-full resize-none rounded-xl border border-border bg-background px-4 py-3 text-sm leading-6 outline-none transition placeholder:text-muted-foreground/70 focus:border-primary focus:ring-2 focus:ring-primary/10 disabled:cursor-not-allowed disabled:opacity-50" data-testid="input-turban-correction" />
        <div className="mt-3 flex flex-wrap gap-2">
          {quickCorrections.map((item) => <button key={item} type="button" onClick={() => onCorrectionChange(item)} disabled={busy} className="rounded-full border border-border bg-background px-3 py-1.5 text-left text-[11px] font-semibold text-muted-foreground transition hover:border-primary hover:text-primary disabled:cursor-not-allowed disabled:opacity-50" data-testid={`button-correction-${item.toLowerCase().replaceAll(' ', '-')}`}>{item}</button>)}
        </div>
      </div>

      <div className="mt-6">
        <button type="button" onClick={onApply} disabled={!canApply} className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl bg-primary px-4 py-3 text-sm font-bold text-primary-foreground transition hover:shadow-md disabled:cursor-not-allowed disabled:opacity-40" data-testid="button-apply-turban-correction">{busy ? 'Fixing your turban…' : 'Apply AI correction'} <Sparkles size={15} /></button>
      </div>
    </section>
  );
}